
const PrimeSelector = {
    view: ({attrs: {containsAll, handleClick}}) => {
        const allIcon = containsAll ? 'on' : 'off';
        
        return <i className={`icon-checkbox-${allIcon}`} onclick={() => handleClick()}></i>;
    }
};
export default PrimeSelector;
